import { groupBy } from 'lodash';

export type KeyboardShortcutGroup = 'Playback' | 'PTZ' ;

export type KeyboardShortcut = {
  /** The user-friendly command name */
  command: string;
  /** The actual hotkey string provided to hotkeys-js */
  hotkey: string;
  /** Keys to display inside keyboard buttons in the UI to represent the shortcut to the user */
  keys: string[];
  /** Determines the specific list in which to place this keyboard shortcut in the modal */
  group: KeyboardShortcutGroup;
};

export const KeyboardShortcutGroups: Record<string, KeyboardShortcutGroup> = {
  Playback: 'Playback',
  PTZ: 'PTZ'
};

export const KeyboardShortcuts: Record<string, KeyboardShortcut> = {
  PlayPause: {
    command: 'Play/Pause',
    hotkey: 'k',
    keys: ['k'],
    group: KeyboardShortcutGroups.Playback,
  },
  ShuttleBackward: {
    command: 'Rewind 10 Seconds',
    hotkey: 'j',
    keys: ['j'],
    group: KeyboardShortcutGroups.Playback,
  },
  ShuttleForward: {
    command: 'Fast Forward 10 Seconds',
    hotkey: 'l',
    keys: ['l'],
    group: KeyboardShortcutGroups.Playback,
  },
  EditTime: {
    command: 'Edit Time',
    hotkey: 't',
    keys: ['t'],
    group: KeyboardShortcutGroups.Playback,
  },
  Mute: {
    command: 'Mute/Unmute',
    hotkey: 'm',
    keys: ['m'],
    group: KeyboardShortcutGroups.Playback,
  },
  Fullscreen: {
    command: 'Fullscreen',
    hotkey: 'f',
    keys: ['f'],
    group: KeyboardShortcutGroups.Playback,
  },
  TiltUp: {
    command: 'Tilt Up',
    hotkey: 'w',
    keys: ['w'],
    group: KeyboardShortcutGroups.PTZ,
  },
  TiltDown: {
    command: 'Tilt Down',
    hotkey: 's',
    keys: ['s'],
    group: KeyboardShortcutGroups.PTZ,
  },
  PanLeft: {
    command: 'Pan Left',
    hotkey: 'a',
    keys: ['a'],
    group: KeyboardShortcutGroups.PTZ,
  },
  PanRight: {
    command: 'Pan Right',
    hotkey: 'd',
    keys: ['d'],
    group: KeyboardShortcutGroups.PTZ,
  },
  ZoomIn: {
    command: 'Zoom In',
    hotkey: 'y',
    keys: ['y'],
    group: KeyboardShortcutGroups.PTZ,
  },
  ZoomOut: {
    command: 'Zoom Out',
    hotkey: 'h',
    keys: ['h'],
    group: KeyboardShortcutGroups.PTZ,
  },
};

export const KeyboardShortcutsList = groupBy(Object.values(KeyboardShortcuts), 'group') as Record<
  KeyboardShortcutGroup,
  KeyboardShortcut[]
>;

export const KeyboardShortcutGroupTitles: Record<KeyboardShortcutGroup, string> = {
  PTZ: 'PTZ Tracking',
  Playback: 'Playback'
};

export const KeyboardShortcutGroupOrderNumber: Record<KeyboardShortcutGroup, number> = {
  Playback: 1,
  PTZ: 2,
};
